import { getApiBase } from "./apiConfig";
import { logger } from "./logger";
import type { TradeRecommendation } from "@shared/types";

const API_BASE = getApiBase();
const RECOMMENDATION_QUEUE_BASE = `${API_BASE}/api/recommendation-queue`;

export interface QueueStatus {
  active_pool_size: number;
  reserve_pool_size: number;
  active_pool_max: number;
  reserve_pool_max: number;
}

async function handleResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const errorText = await response.text().catch(() => "Unknown error");
    throw new Error(`API error: ${response.status} - ${errorText}`);
  }

  try {
    return (await response.json()) as T;
  } catch (error) {
    throw new Error("Failed to parse response as JSON");
  }
}

export async function getQueueStatus(): Promise<QueueStatus> {
  const response = await fetch(`${RECOMMENDATION_QUEUE_BASE}/status`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

  return handleResponse<QueueStatus>(response);
}

export async function getActiveRecommendations(): Promise<TradeRecommendation[]> {
  const response = await fetch(`${RECOMMENDATION_QUEUE_BASE}/active`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

  return handleResponse<TradeRecommendation[]>(response);
}

export async function getReserveRecommendations(): Promise<TradeRecommendation[]> {
  const response = await fetch(`${RECOMMENDATION_QUEUE_BASE}/reserve`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

  return handleResponse<TradeRecommendation[]>(response);
}

